// @flow
import { get, toNumber } from 'lodash';

// services, payments and receipts each keep one list in the store, for one patient (currentPatientId, set when the
// request starts) or for a report (no patient: NaN). An answer counts only if it is for that same request: a late
// answer for the previous patient, or for a report, would otherwise replace the list on screen with another one.
export const isCurrentListAnswer = (state: Object, list: 'services' | 'payments' | 'receipts', patientId: ?(number | string)): boolean => {
  const current = get(state, [list, 'currentPatientId']);
  if (current === undefined || current === null) return true;
  return Object.is(current, toNumber(patientId));
};
